export default __webpack_public_path__ + "assets/40b7ccafd4cfbe2a5b664a9082e7f27c.jpg";